const KYB_STATUSES = Object.freeze({
  UNSPECIFIED: 'unspecified',
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  APPROVED: 'approved',
  DECLINED: 'declined',
})

const KYB_STATUS_VALUES = Object.freeze(Object.values(KYB_STATUSES))

const ACCOUNT_GETTERS = {
  requisites: 'account/requisites',
  isLoading: 'account/isLoading',
  isLoaded: 'account/isLoaded',

  kybStatus: 'account/kybStatus',
  kybStatusUpdatedAt: 'account/kybStatusUpdatedAt',
  isKybStatusLoading: 'account/isKybStatusLoading',
  isKybStatusLoaded: 'account/isKybStatusLoaded',
  isKybNotStarted: 'account/isKybNotStarted',
  isKybInProgress: 'account/isKybInProgress',
  isKybApproved: 'account/isKybApproved',
  isKybDeclined: 'account/isKybDeclined',
}

const ACCOUNT_DISPATCHERS = {
  fetchRequisites: 'account/fetchRequisites',
  fetchKybStatus: 'account/fetchKybStatus',
  resetAccount: 'account/resetAccount',
}

export { ACCOUNT_GETTERS, ACCOUNT_DISPATCHERS, KYB_STATUSES, KYB_STATUS_VALUES }
